import { LinkableEntityType } from '@api';
import { LegacyAnchor } from '@common';

type TeamAnchorPropsType = {
  team: LinkableEntityType;
  children?: React.ReactNode;
};

export const TeamAnchor: React.FC<TeamAnchorPropsType> = ({
  team,
  children,
}) => {
  return (
    <LegacyAnchor href={`/system/groups/${team.id}`}>
      {children ?? team.name}
    </LegacyAnchor>
  );
};
